import React, { useEffect, useState } from "react";
import { Card, Col, Descriptions, Row } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import { useLocation } from "react-router-dom";
import TableComponent from "../common/table/TableComponent";

function DetailedResult() {
  const innerTableColumns = [
    {
      title: "Section Name",
      dataIndex: "section_name",
    },
    {
      title: "Total Question",
      dataIndex: "total_question",
    },
    {
      title: "Total Marks",
      dataIndex: "total_marks",
    },
    {
      title: "Total Attempted",
      dataIndex: "total_attempted",
    },
    {
      title: "Correct Question",
      dataIndex: "correct_questions",
    },
    {
      title: "Marks Obtained",
      dataIndex: "marks_obtained",
    },
  ];
  const location = useLocation();
  const [getDetailedResultResponse, getDetailedResultRequest] = useApi(
    "/admin/student/get-result",
    null,
    API_METHODS.GET
  );

  const [result, setResult] = useState([]);
  const [items, setItems] = useState();
  const [innerTableData, setinnerTableData] = useState([]);

  useEffect(() => {
    getDetailedResultRequest(
      null,
      API_METHODS.GET,
      `/admin/student/get-result?student_id=${location.state.student_id}&&test_id=${location.state.test_id}&&test_session_id=${location.state.id}`
    );
  }, []);

  useEffect(() => {
    const data =
      getDetailedResultResponse.data !== BLANK_VALUE
        ? getDetailedResultResponse.data
        : [];
    setResult(data);
    if (data) {
      let items = [
        {
          key: "1",
          label: "Test Type",
          children: data.test_type,
        },
        {
          key: "2",
          label: "Total Question",
          children: data.total_questions,
        },
        {
          key: "3",
          label: "Total Marks",
          children: data.total_marks,
        },
        {
          key: "4",
          label: "Total Attempted",
          children: data.total_attempted,
        },
        {
          key: "5",
          label: "Correct Questions",
          children: data.correct_questions,
        },
        {
          key: "6",
          label: "Marks Obtained",
          children: data.marks_obtained,
        },
      ];
      setItems(items);
      if (data.test_type == 3) {
        setinnerTableData(data.sectionwise_result);
      }
    }
  }, [getDetailedResultResponse]);

  return (
    <Card title={"Result"}>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <b>Test Name : {location.state.name}</b>
        </Col>
        <Col span={6}>
          <b>Month : {location.state.month}</b>
        </Col>
        <Col span={6}>
          <b>Week : {location.state.week}</b>
        </Col>
        <Col span={6}>
          <b>Mock Test Number : {location.state.mock_test_number}</b>
        </Col>
        <Col span={24}>
          <b>Description : {location.state.description}</b>
        </Col>
      </Row>
      {result && (
        <Descriptions
          bordered
          items={items}
          style={{ margin: 5, paddingTop: 20 }}
        />
      )}
      {result && result.test_type == 3 && innerTableData.length > 0 && (
        <TableComponent
          columns={innerTableColumns}
          tableData={innerTableData}
        />
      )}
    </Card>
  );
}

export default DetailedResult;
